import AMapLoader from "@amap/amap-jsapi-loader";

export function Loader(id,succall,errcall,type) {
	return new Promise((resolve, reject) => {
		AMapLoader.load({
			key: "3dd92d7bf523ed8688e0d921e77cfd1a", // 第三方
			// key: "a0ca492e162cecc4071d84b57de3b1ce", // 正式
			// key: "6908da7f2459112ea604ad064a1cebbc", // 我的
			version: "2.0",
			plugins: ["AMap.Geolocation", "AMap.CitySearch", "AMap.PlaceSearch","AMap.AutoComplete"],
		})
			.then((AMap) => {
                let map = new AMap.Map(id)
                if(succall && errcall){
                    if(type == 1){
                        AMap.plugin("AMap.CitySearch", () => {
                            let city = new AMap.CitySearch();
                            city.getLocalCity(succall,errcall);
                        });
                    }else if(type ==2){
                        AMap.plugin("AMap.Geolocation", () => {
                            let geolocation = new AMap.Geolocation({
                                enableHighAccuracy: false,
                                timeout: 10000,
                                maximumAge: 0,
                                convert: true,
                                extensions: "all",
                            });
                            map.addControl(geolocation)
                            geolocation.getCurrentPosition(succall,errcall);
                        });
                    }else{
                        AMap.plugin("AMap.CitySearch", () => {
                            let city = new AMap.CitySearch();
                            city.getLocalCity(succall,errcall);
                        });
                        AMap.plugin("AMap.Geolocation", () => {
                            let geolocation = new AMap.Geolocation({
                                enableHighAccuracy: false,
                                timeout: 10000,
                                maximumAge: 0,
                                convert: true,
                                extensions: "all",
                            });
                            map.addControl(geolocation)
                            geolocation.getCurrentPosition(succall,errcall);
                        });
                    }
                }
                resolve(AMap);
			})
			.catch((e) => {
				reject(e);
			});
	});
}
